import { cn } from "@/libs";
import { ComponentBase } from "@/types";
import { useTitle } from "ahooks";
import { Space } from "antd-mobile";
import React from "react";
import { CustomerIcon } from "../CustomerIcon";
import { MessageIcon } from "../MessageIcon";
import styles from "./styles.module.scss";
export interface RootHeaderProps extends ComponentBase.BaseComponent {
  title: string;
  right?: React.ReactNode;
}
export const RootHeader = ({
  title,
  right,
  className
}: RootHeaderProps) => {
  useTitle(title, {
    restoreOnUnmount: true
  });
  return <div className={cn(styles.header, className)} data-sentry-component="RootHeader" data-sentry-source-file="index.tsx">
      <div className={styles.logo}></div>
      <div className={styles.empty} />
      {right ?? <Space>
          <div>
            <MessageIcon count={12} />
          </div>
          <div>
            <CustomerIcon />
          </div>
        </Space>}
    </div>;
};